import { EditMode } from '../configurator/model/edit-mode';
import { Renderer } from '../configurator/renderer';
import { EditState } from '../configurator';
import { isAreasDataValid } from '../configurator/validators/validators';
import { debounce } from '../configurator/helpers';
import { Translator } from '../configurator/translator';

export default class FacingConfigurator {
  constructor(options = {}) {
    ({
      canvasSelector: this.canvasSelector,
      inputSelector: this.inputSelector,
      onInited: this.onInited,
      translations: this.translations,
      formatPatternScale: this.formatPatternScale,
    } = options);
    if (!isAreasDataValid(options.areas)) {
      console.error('configurator inputs are not valid');
      return;
    }

    if (options.editModeKey) {
      this.editMode = EditMode[options.editModeKey];
    }

    this.editState = this.createEditState(options.areas);
    this.translator = new Translator({ translations: options.translations });

    this.renderer = new Renderer({
      canvasSelector: this.canvasSelector,
      editState: this.editState,
      editMode: EditMode.SHAPEONLY,
      onAfterInit: this.onAfterInit.bind(this),
      translator: this.translator,
      formatPatternScale: this.formatPatternScale,
    });

    this.handleOnPageResize();
  }

  createEditState(rawareas) {
    let descriptorsCount = 0;
    rawareas.forEach(area => {
      if (area.data.descriptor) {
        descriptorsCount++;
      }
    });
    if (descriptorsCount && rawareas.length !== descriptorsCount) {
      throw Error('Not every area has its own descriptor, that should not happen');
    } else {
      return new EditState({ rawAreas: rawareas });
    }
  }

  onAfterInit() {
    let sumLength = 0;
    for (const planarea of this.renderer.planareas) {
      for (const border of planarea.borders) {
        const isSplitEdge = planarea.areaState.hasConnectionOnIndex(border.index);
        if (!isSplitEdge) {
          sumLength += Math.round(Math.abs(border.getLength()));
        }
      }
    }
    const input = document.querySelector(this.inputSelector);
    if (input) {
      input.value = input.dataset.sum = sumLength;
      if (this.onInited) {
        this.onInited();
      }
    }
  }

  handleOnPageResize() {
    window.addEventListener(
      'resize',
      debounce(() => {
        this.renderer.fitPlanToView();
        this.renderer.redraw();
      }, 100)
    );
  }
}
